import "/__w/1/s/BotFramework-WebChat/packages/component/src/Activity/StackedLayout.module_built.css";
const classes = {"stacked-layout__attachment-list":"wRAis8G_stacked-layout__attachment-list","stacked-layout__message-status-unset-icon":"wRAis8G_stacked-layout__message-status-unset-icon","stacked-layout__message-status-loader":"wRAis8G_stacked-layout__message-status-loader","stacked-layout__attachment":"wRAis8G_stacked-layout__attachment","stacked-layout__message-status--unset":"wRAis8G_stacked-layout__message-status--unset","stacked-layout__message-status":"wRAis8G_stacked-layout__message-status","stacked-layout__message-status-complete-icon":"wRAis8G_stacked-layout__message-status-complete-icon","stacked-layout--from-user":"wRAis8G_stacked-layout--from-user","stacked-layout__content":"wRAis8G_stacked-layout__content","stacked-layout__title":"wRAis8G_stacked-layout__title","stacked-layout__nub-pad":"wRAis8G_stacked-layout__nub-pad","stacked-layout__avatar-gutter":"wRAis8G_stacked-layout__avatar-gutter","stacked-layout__bubble":"wRAis8G_stacked-layout__bubble","stacked-layout__message-row":"wRAis8G_stacked-layout__message-row","stacked-layout__attachment-row":"wRAis8G_stacked-layout__attachment-row","stacked-layout__status":"wRAis8G_stacked-layout__status","stacked-layout--no-message":"wRAis8G_stacked-layout--no-message","stacked-layout--top-callout":"wRAis8G_stacked-layout--top-callout","stacked-layout--group":"wRAis8G_stacked-layout--group","stacked-layout__main":"wRAis8G_stacked-layout__main","stacked-layout__message-status--incomplete":"wRAis8G_stacked-layout__message-status--incomplete","stacked-layout--show-avatar":"wRAis8G_stacked-layout--show-avatar","stacked-layout--extra-trailing":"wRAis8G_stacked-layout--extra-trailing","stacked-layout__message-status--published":"wRAis8G_stacked-layout__message-status--published","stacked-layout__alignment-pad":"wRAis8G_stacked-layout__alignment-pad","stacked-layout--hide-nub":"wRAis8G_stacked-layout--hide-nub","stacked-layout":"wRAis8G_stacked-layout","stacked-layout--activity":"wRAis8G_stacked-layout--activity","stacked-layout--show-nub":"wRAis8G_stacked-layout--show-nub","stacked-layout__message":"wRAis8G_stacked-layout__message","stacked-layout--hide-avatar":"wRAis8G_stacked-layout--hide-avatar"}
export default classes

const _stacked_layout__attachment_list0 = classes["stacked-layout__attachment-list"]
export { _stacked_layout__attachment_list0 as "stacked-layout__attachment-list" }

const _stacked_layout__message_status_unset_icon0 = classes["stacked-layout__message-status-unset-icon"]
export { _stacked_layout__message_status_unset_icon0 as "stacked-layout__message-status-unset-icon" }

const _stacked_layout__message_status_loader0 = classes["stacked-layout__message-status-loader"]
export { _stacked_layout__message_status_loader0 as "stacked-layout__message-status-loader" }

const _stacked_layout__attachment0 = classes["stacked-layout__attachment"]
export { _stacked_layout__attachment0 as "stacked-layout__attachment" }

const _stacked_layout__message_status__unset0 = classes["stacked-layout__message-status--unset"]
export { _stacked_layout__message_status__unset0 as "stacked-layout__message-status--unset" }

const _stacked_layout__message_status0 = classes["stacked-layout__message-status"]
export { _stacked_layout__message_status0 as "stacked-layout__message-status" }

const _stacked_layout__message_status_complete_icon0 = classes["stacked-layout__message-status-complete-icon"]
export { _stacked_layout__message_status_complete_icon0 as "stacked-layout__message-status-complete-icon" }

const _stacked_layout__from_user0 = classes["stacked-layout--from-user"]
export { _stacked_layout__from_user0 as "stacked-layout--from-user" }

const _stacked_layout__content0 = classes["stacked-layout__content"]
export { _stacked_layout__content0 as "stacked-layout__content" }

const _stacked_layout__title0 = classes["stacked-layout__title"]
export { _stacked_layout__title0 as "stacked-layout__title" }

const _stacked_layout__nub_pad0 = classes["stacked-layout__nub-pad"]
export { _stacked_layout__nub_pad0 as "stacked-layout__nub-pad" }

const _stacked_layout__avatar_gutter0 = classes["stacked-layout__avatar-gutter"]
export { _stacked_layout__avatar_gutter0 as "stacked-layout__avatar-gutter" }

const _stacked_layout__bubble0 = classes["stacked-layout__bubble"]
export { _stacked_layout__bubble0 as "stacked-layout__bubble" }

const _stacked_layout__message_row0 = classes["stacked-layout__message-row"]
export { _stacked_layout__message_row0 as "stacked-layout__message-row" }

const _stacked_layout__attachment_row0 = classes["stacked-layout__attachment-row"]
export { _stacked_layout__attachment_row0 as "stacked-layout__attachment-row" }

const _stacked_layout__status0 = classes["stacked-layout__status"]
export { _stacked_layout__status0 as "stacked-layout__status" }

const _stacked_layout__no_message0 = classes["stacked-layout--no-message"]
export { _stacked_layout__no_message0 as "stacked-layout--no-message" }

const _stacked_layout__top_callout0 = classes["stacked-layout--top-callout"]
export { _stacked_layout__top_callout0 as "stacked-layout--top-callout" }

const _stacked_layout__group0 = classes["stacked-layout--group"]
export { _stacked_layout__group0 as "stacked-layout--group" }

const _stacked_layout__main0 = classes["stacked-layout__main"]
export { _stacked_layout__main0 as "stacked-layout__main" }

const _stacked_layout__message_status__incomplete0 = classes["stacked-layout__message-status--incomplete"]
export { _stacked_layout__message_status__incomplete0 as "stacked-layout__message-status--incomplete" }

const _stacked_layout__show_avatar0 = classes["stacked-layout--show-avatar"]
export { _stacked_layout__show_avatar0 as "stacked-layout--show-avatar" }

const _stacked_layout__extra_trailing0 = classes["stacked-layout--extra-trailing"]
export { _stacked_layout__extra_trailing0 as "stacked-layout--extra-trailing" }

const _stacked_layout__message_status__published0 = classes["stacked-layout__message-status--published"]
export { _stacked_layout__message_status__published0 as "stacked-layout__message-status--published" }

const _stacked_layout__alignment_pad0 = classes["stacked-layout__alignment-pad"]
export { _stacked_layout__alignment_pad0 as "stacked-layout__alignment-pad" }

const _stacked_layout__hide_nub0 = classes["stacked-layout--hide-nub"]
export { _stacked_layout__hide_nub0 as "stacked-layout--hide-nub" }

const _stacked_layout0 = classes["stacked-layout"]
export { _stacked_layout0 as "stacked-layout" }

const _stacked_layout__activity0 = classes["stacked-layout--activity"]
export { _stacked_layout__activity0 as "stacked-layout--activity" }

const _stacked_layout__show_nub0 = classes["stacked-layout--show-nub"]
export { _stacked_layout__show_nub0 as "stacked-layout--show-nub" }

const _stacked_layout__message0 = classes["stacked-layout__message"]
export { _stacked_layout__message0 as "stacked-layout__message" }

const _stacked_layout__hide_avatar0 = classes["stacked-layout--hide-avatar"]
export { _stacked_layout__hide_avatar0 as "stacked-layout--hide-avatar" }
